<template>
  <div>
    <div class="lg:flex md:flex">
      <div class="location-home lg:mb-0 md:mb-0 mb-4">
        <h3 class="fsize16 font-semibold">
          Home /
          {{
            $route.query.location ? $route.query.location : $route.query.service
          }}
        </h3>
      </div>
    </div>
    <div class="flex ml-auto w-full my-2">
      <!-- <b-form-input
        id="input-default"
        label-size="large"
        class=""
        placeholder="Search Name"
      ></b-form-input>

      <div class="search">
        <b-button variant="secondary" class="search-clr-btn ml-2"
          >Search</b-button
        >
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("respitecare", {
      get_location: "get_location",
    }),
  },
};
</script>

<style>
.search-clr-btn {
  color: #f8f9fe;
  background-color: #4f0a4b;
}
</style>
